/**
 * ISO 4217 currency options for all Google Ads supported currencies.
 * Mirrors backend/app/utils/currency.py — keep in sync.
 */

/** Quick-access currencies shown above the divider. */
export const SHORTCUT_CURRENCIES = ['EUR', 'USD', 'GBP'] as const;

export const CURRENCY_OPTIONS = [
  { code: 'ARS', symbol: 'AR$', label: 'ARS (AR$)' },
  { code: 'AUD', symbol: 'A$', label: 'AUD (A$)' },
  { code: 'BDT', symbol: '৳', label: 'BDT (৳)' },
  { code: 'BGN', symbol: 'лв', label: 'BGN (лв)' },
  { code: 'BOB', symbol: 'Bs', label: 'BOB (Bs)' },
  { code: 'BRL', symbol: 'R$', label: 'BRL (R$)' },
  { code: 'CAD', symbol: 'C$', label: 'CAD (C$)' },
  { code: 'CHF', symbol: 'CHF', label: 'CHF' },
  { code: 'CLP', symbol: 'CL$', label: 'CLP (CL$)' },
  { code: 'CNY', symbol: '¥', label: 'CNY (¥)' },
  { code: 'COP', symbol: 'CO$', label: 'COP (CO$)' },
  { code: 'CZK', symbol: 'Kč', label: 'CZK (Kč)' },
  { code: 'DKK', symbol: 'kr', label: 'DKK (kr)' },
  { code: 'EGP', symbol: 'E£', label: 'EGP (E£)' },
  { code: 'EUR', symbol: '€', label: 'EUR (€)' },
  { code: 'GBP', symbol: '£', label: 'GBP (£)' },
  { code: 'GEL', symbol: '₾', label: 'GEL (₾)' },
  { code: 'HKD', symbol: 'HK$', label: 'HKD (HK$)' },
  { code: 'HRK', symbol: 'kn', label: 'HRK (kn)' },
  { code: 'HUF', symbol: 'Ft', label: 'HUF (Ft)' },
  { code: 'IDR', symbol: 'Rp', label: 'IDR (Rp)' },
  { code: 'ILS', symbol: '₪', label: 'ILS (₪)' },
  { code: 'INR', symbol: '₹', label: 'INR (₹)' },
  { code: 'JPY', symbol: '¥', label: 'JPY (¥)' },
  { code: 'KRW', symbol: '₩', label: 'KRW (₩)' },
  { code: 'KZT', symbol: '₸', label: 'KZT (₸)' },
  { code: 'MAD', symbol: 'MAD', label: 'MAD' },
  { code: 'MXN', symbol: 'MX$', label: 'MXN (MX$)' },
  { code: 'MYR', symbol: 'RM', label: 'MYR (RM)' },
  { code: 'NGN', symbol: '₦', label: 'NGN (₦)' },
  { code: 'NOK', symbol: 'kr', label: 'NOK (kr)' },
  { code: 'NZD', symbol: 'NZ$', label: 'NZD (NZ$)' },
  { code: 'PEN', symbol: 'S/', label: 'PEN (S/)' },
  { code: 'PHP', symbol: '₱', label: 'PHP (₱)' },
  { code: 'PKR', symbol: 'Rs', label: 'PKR (Rs)' },
  { code: 'PLN', symbol: 'zł', label: 'PLN (zł)' },
  { code: 'RON', symbol: 'lei', label: 'RON (lei)' },
  { code: 'RUB', symbol: '₽', label: 'RUB (₽)' },
  { code: 'SAR', symbol: 'SAR', label: 'SAR' },
  { code: 'SEK', symbol: 'kr', label: 'SEK (kr)' },
  { code: 'SGD', symbol: 'S$', label: 'SGD (S$)' },
  { code: 'THB', symbol: '฿', label: 'THB (฿)' },
  { code: 'TRY', symbol: '₺', label: 'TRY (₺)' },
  { code: 'TWD', symbol: 'NT$', label: 'TWD (NT$)' },
  { code: 'UAH', symbol: '₴', label: 'UAH (₴)' },
  { code: 'USD', symbol: '$', label: 'USD ($)' },
  { code: 'VND', symbol: '₫', label: 'VND (₫)' },
  { code: 'ZAR', symbol: 'R', label: 'ZAR (R)' },
] as const;
